<template>
  <v-card class="invoice-card" flat>
    <v-row>
      <v-col cols="12">
        <span class="invoice-card__title" :inner-html.prop="invoiceFullNumber">
        </span>
        <span class="commands float-right">
          <ButtonActionFursHistory @click="showFursHistory" />
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="invoice-card__details">
        <span>
          {{invoice.date | sloDateTime}}
          <span class="d-none d-sm-inline-block invoice-card__details__devider"></span><br class="d-sm-none">
          {{invoice.moniker}}
          <span class="d-none d-sm-inline-block invoice-card__details__devider"></span><br class="d-sm-none">
          {{paymentType}}
        </span>
        <span class="float-right invoice-card__total" :inner-html.prop="invoice.payment_amount | price">
        </span>
      </v-col>
    </v-row>
    <v-row v-if="invoice.furs" style="border-top: 1px solid lightgrey; margin: 20px 10px 0 10px;">
      <v-row>
        <v-col cols="12">
          <h4 class="d-inline-block">FURS komunikacija:</h4>
          <span class="float-right">
            <ButtonActionToggleVisible :active="showFursCommunication" @click="showFursCommunication = !showFursCommunication" />
          </span>
        </v-col>
      </v-row>
      <v-col cols="12" v-if="showFursCommunication">
        <FursCommunicationRow v-for="communication in invoice.furs" :key="communication.requestId" :communication="communication" />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import ButtonActionToggleVisible from './ButtonActionToggleVisible'
import ButtonActionFursHistory from './ButtonActionFursHistory'
import FursCommunicationRow from './FursCommunicationRow'

export default {
  components: {
    ButtonActionToggleVisible,
    FursCommunicationRow,
    ButtonActionFursHistory
  },
  props: {
    childCompanyId: {
      required: true,
      type: Number
    },
    invoice: {
      required: true,
      type: Object
    },
    businessUnitCode: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      showFursCommunication: true
    }
  },
  computed: {
    invoiceFullNumber () {
      return `${this.businessUnitCode}-${this.invoice.electronic_device_id}-<span style="font-weight: bold; font-size: 25px;">${this.invoice.number}</span>`
    },
    paymentType () {
      return this.invoice.payment_type_name.toUpperCase()
    }
  },
  methods: {
    ...mapActions('clientsInvoices', ['getCommunicationData']),
    showFursHistory () {
      this.getCommunicationData({ childCompanyId: this.childCompanyId, invoiceId: this.invoice.id })
        .then(response => {
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.invoice-card {
  padding: 0 15px;
  font-size: 20px;
  border: 2px solid #EDEDED;

  &__details {
    line-height: 20px;
    font-size: 16px;
    color: #505B75;
    &__devider {
      width: 1px;
      height: 100%;
      margin: 0 15px 0 13px;
      border-right: 2px solid #EDEDED;
    }
  }
  &__total {
    padding-right: 20px;
    font-size: 25px;
    font-weight: bold;
  }
  .commands {
    margin-right: 20px;
  }
}
</style>
